import React, { useEffect, useState } from "react";
import { Box, TextField, MenuItem, Button } from "@mui/material";
import { LOT_STATUS_TYPES } from "../api/lotStatusService";

const LotStatusFilter = ({ initialFilters = {}, onApply, onClear }) => {
  const [code, setCode] = useState(" ");
  const [lotStatusType, setLotStatusType] = useState(
    initialFilters.lotStatusType || "",
  );

  useEffect(() => {
    console.log(lotStatusType);
  }, [lotStatusType]);

  const handleApply = () => {
    onApply({ code, lotStatusType });
  };

  const handleClear = () => {
    setCode("");
    setLotStatusType("");
    onClear();
  };

  return (
    <Box display="flex" gap={2} alignItems="center" mb={2} flexWrap="wrap">
      <TextField
        label="Code"
        size="small"
        value={code}
        onChange={(e) => setCode(e.target.value)}
      />

      <TextField
        select
        label="Статус"
        size="small"
        sx={{ minWidth: 180 }}
        value={lotStatusType}
        onChange={(e) => setLotStatusType(e.target.value)}
      >
        <MenuItem value="">Все</MenuItem>
        {LOT_STATUS_TYPES.map((type) => (
          <MenuItem key={type} value={type}>
            {type}
          </MenuItem>
        ))}
      </TextField>

      <Button variant="contained" onClick={handleApply}>
        Применить
      </Button>
      <Button variant="outlined" onClick={handleClear}>
        Сбросить
      </Button>
    </Box>
  );
};

export default LotStatusFilter;
